import cn from "classnames"

import { useBookingContext } from "modules/Booking/BookingContext"
import { useGetServicePrice } from "modules/Booking/common/hooks"
import { Discount, Price } from "components"
import { useOnlyFreeSessions } from "pages/FreePsysPage/useOnlyFreeSessions"
import { renderCityWithDetails } from "utils/helpers/psychologistUtil"
import { useShowPrice } from "utils/hooks/useShowPrice"

interface Props {
    className?: string
    isShowSessionDuration?: boolean
}

export function PriceAndTime({ className, isShowSessionDuration }: Props) {
    const [{ psy, isOnline, slotDuration, hasPreviousSessionsWithSamePsychologist, currency }] =
        useBookingContext()
    const onlyFree = useOnlyFreeSessions()
    const [price, discountPrice] = useGetServicePrice()
    const showPrice = useShowPrice()

    const priceAndDiscount = (function () {
        if (!showPrice) return null
        return (
            <div className="price-and-time__discount__container">
                {onlyFree && <>Бесплатно</>}
                {!onlyFree && (
                    <>
                        <Price psy={psy} singleServicePrice={discountPrice} currency={currency} />
                        <Discount
                            psy={psy}
                            singleServicePrice={price}
                            className="price-and-time__discount price-and-discount__discount-strikethrough"
                        />
                    </>
                )}
            </div>
        )
    })()

    const duration = (function () {
        if (!isShowSessionDuration || hasPreviousSessionsWithSamePsychologist || !slotDuration) {
            return null
        }
        return <>{slotDuration} минут</>
    })()

    const cityWithDetails = renderCityWithDetails(psy.new_city.name, psy.city_details)

    return (
        <div className={cn("price-and-time", className)}>
            <span className="price-and-time__first">
                {priceAndDiscount}
                {priceAndDiscount && duration && <>, </>}
                {duration}
            </span>
            {!isOnline && !hasPreviousSessionsWithSamePsychologist && (
                <span className="price-and-time__second">
                    {(priceAndDiscount || duration) && cityWithDetails && (
                        <span className="session-date__session-info-bullet">•</span>
                    )}
                    {cityWithDetails}
                </span>
            )}
        </div>
    )
}
